import { Creators as UserActions } from '../../shared/store/ducks/user'
import { Creators as TokenActions } from '../../shared/store/ducks/token'
import { store } from '../store'

export const logout = (): void => {
	store.dispatch(UserActions.resetUser())
	store.dispatch(TokenActions.resetToken())
}
